import {
  BasicModal,
  CardComponent,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { Grid } from '@mui/material';

export interface AddCheckoffListModalProps {
  name: string;
  notes?: string;
   
  onChange: (field: 'name' | 'notes', value: string) => void;
  onSave: () => void;
  onClose: () => void;
  title?: string;
}

const MAX_VISIBLE_NOTES = 5;

const AddNotesCheckoffListModal: React.FC<AddCheckoffListModalProps> = ({
  name,
  notes,
  onChange,
  onSave,
  onClose,
}) => {
  const [notesList, setNotesList] = React.useState<string[]>(
    notes ? notes.split('\n') : [''],
  );

  // 🔹 Ref for scroll container
  const notesContainerRef = React.useRef<HTMLDivElement | null>(null);

  const handleAddNote = () => {
    const updated = [...notesList, ''];
    setNotesList(updated);
    onChange('notes', updated.join('\n'));
  };

  // 🔹 Auto-scroll to bottom when notes exceed visible limit
  React.useEffect(() => {
    if (notesList.length > MAX_VISIBLE_NOTES && notesContainerRef.current) {
      notesContainerRef.current.scrollTop =
        notesContainerRef.current.scrollHeight;
    }
  }, [notesList.length]);

  return (
    <BasicModal
      title={name || ''}
      open={true}
      handleClose={onClose}
      width="650px"
      body={
        <CardComponent
          title=""
          mainGridStyles={{
            background: patientAccessTheme.palette.background.default,
          }}
          body={
            <>
              {/* Notes */}
              <ReportCreateNewLabelField
                label="Notes (Optional)"
                width="100%"
                component={
                  <div
                    ref={notesContainerRef}
                    style={{
                      maxHeight:
                        notesList.length > MAX_VISIBLE_NOTES ? '220px' : 'auto',
                      overflowY:
                        notesList.length > MAX_VISIBLE_NOTES
                          ? 'auto'
                          : 'visible',
                      paddingRight: '4px',
                    }}
                  >
                    {notesList?.map((note, index) => (
                      <Grid
                        key={index}
                        style={{
                          display: 'flex',
                          gap: '8px',
                          marginBottom: '8px',
                        }}
                      >
                        <TextField
                          value={note}
                          fullWidth
                          height="36px"
                          placeholder={`Note ${index + 1}`}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            const updated = [...notesList];
                            updated[index] = e.target.value;
                            setNotesList(updated);
                            onChange('notes', updated.join('\n'));
                          }}
                        />

                        {notesList.length > 1 && (
                          <Typography
                            cursor="pointer"
                            fontSize="14px"
                            textColor="#E53935"
                            onClick={() => {
                              const updated = notesList.filter(
                                (_, i) => i !== index,
                              );
                              setNotesList(updated);
                              onChange('notes', updated.join('\n'));
                            }}
                          >
                            ✕
                          </Typography>
                        )}
                      </Grid>
                    ))}
                  </div>
                }
              />

              {/* Add Notes Button */}
              <Grid style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Typography
                  textColor="#475CB0"
                  cursor="pointer"
                  fontSize="12px"
                  onClick={handleAddNote}
                >
                  Add Notes +
                </Typography>
              </Grid>
            </>
          }
        />
      }
      isConfirmDisabled={name?.trim() === ''}
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Save"
      handleCancel={onClose}
      handleConfirm={onSave}
    />
  );
};

export default AddNotesCheckoffListModal;
